import { Navigate } from 'react-router-dom';

export default function FamilyMembers() {
  return <Navigate to="/admin/customers" replace />;
}
